import Vue from 'vue';
import store from '@/store';
import {MapActionsSnackbarModule} from "@/store/modules/snackbar/map-actions.snackbar";
import ClienteModel from "@/models/cliente/cliente.model";
import {ClienteFilter} from "@/models/cliente/cliente-filter.interface";
import queryUtil from '@/util/query.util';
import AcompanhamentoModel from "@/models/cliente/acompanhamento.model";
import SyncModel from "@/models/cliente/sync.model";

class ClienteService {

    STATUS_OK: number = 200;

    async cadastrar(body: ClienteModel): Promise<any> {
        return await Vue.prototype.$axios.post('clientes', body)
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Dados salvos com sucesso!');
                    const cliente: ClienteModel = response.data;
                    return cliente;
                }
            })
            .catch((error: any) => {
                store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
                console.error(error.response);
            });
    }

    async atualizar(body: ClienteModel): Promise<any> {
        return await Vue.prototype.$axios.put(`clientes/${body.id}`, body)
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Dados atualizados com sucesso!');
                    const cliente: ClienteModel = response.data;
                    return cliente;
                }
            })
            .catch((error: any) => {
                store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
                console.error(error.response);
            });
    }

    async buscarComFiltro(filtro: ClienteFilter | undefined): Promise<any> {
        const query = queryUtil.getQuery(filtro);
        return await Vue.prototype.$axios.get(`filter/clientes${query}`)
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    const lista: Array<ClienteModel> = response.data;
                    if (lista.length === 0) {
                        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, 'Nenhum cliente encontrado');
                    }
                    return lista;
                } else {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, 'Falha inesperada ao carregar a lista de clientes');
                }
            })
            .catch((error: any) => {
                console.error(error.response);
            });
    }

    async get(id: string): Promise<any> {
        return await Vue.prototype.$axios.get(`clientes/${id}`)
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    const cliente: ClienteModel = response.data;
                    return cliente;
                } else {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, 'Falha inesperada ao carregar cliente');
                }
            })
            .catch((error: any) => {
                console.error(error.response);
            });
    }

    async delete(id: number | null): Promise<any> {
        await Vue.prototype.$axios.delete(`clientes/${id}`)
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Cliente deletado com sucesso!');
                }
            })
            .catch((error: any) => {
                console.error(error.response);
            });
    }

    async buscarAcompanhamento(idCliente: number | null): Promise<any> {
        return await Vue.prototype.$axios.get(`clientes/${idCliente}/acompanhamento`)
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    const lista: Array<AcompanhamentoModel> = response.data;
                    return lista;
                }
            })
            .catch((error: any) => {
                console.error(error.response);
            });
    }

    async sync(): Promise<any> {
        return await Vue.prototype.$axios.post('clientes/sync')
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    const retorno: SyncModel = response.data;
                    return retorno;
                }
            })
            .catch((error: any) => {
                store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
                console.error(error.response);
            });
    }

}

export default new ClienteService();
